<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Marque :</label>
        </div>
        <div class="col-4">
          <Dropdown
              v-model="marque"
              :options="marqueLibelles"
              :showClear="true"
              :filter="true"
              optionValue="valeur"
              optionLabel="texte"
              scrollHeight="205px"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row solid-line"/>
  <div class="row">
    <div class="col">
      <Button @click="redirectionAjouterModele"> Ajouter</Button>
    </div>
    <div class="col">
      <Button @click="redirectionMarque"> Marque</Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer</Button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['rechercher', 'fermer'],
  props: ['marqueLibelles'],
  data() {
    return {
      marque: null,
    }
  },
  methods: {
    redirectionAjouterModele() {
      this.$router.push({name: 'ajouterModele'});
    },
    redirectionMarque() {
      this.$router.push({name: 'classementMarque'});
    },
    fermer() {
      this.$emit('fermer');
    }
  },
  watch: {
    marque: function (val) {
      this.$emit('rechercher', val);
    },
  },
}
</script>
